export default __webpack_public_path__ + "static/media/not-authorized.e62938f3.svg";